module.exports = __webpack_public_path__ + "static/media/map-icon-polygon.ee129438.svg";